<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const PROTECTIVE_CAT = 'get_protective_cat.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'protectiveCat',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: '',
			id: null
		},
		watch: {
			id(val) {
				if(val) {
					this.selected = val
				}
			}
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_protective_cat`, {index: this.line_count, value: this.selected})
				//EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
			}
		},
		created: function () {
			fetch(DB + PROTECTIVE_CAT, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.id ? this.id : data[0].id
					this.change()
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// protectiveCat.vue?9d743a68